// extracted by css-extract-rspack-plugin
export default {"dropdown":"nmz7i","tooltip":"lgH6L","target":"uZBFj"};